module.exports = __webpack_public_path__ + "media/images/partners_page/personal_shopper_bags-7d29d14550359bc52dc785526e040a36.png";